<template>
  <div class="patentList fatherHeight contBox">
    <div>
      <div class="search-top">
        <el-form :inline="true" :model="searchData" ref="searchForm" class="demo-form-inline" :label-width="80"
          label-suffix=":">
          <el-form-item label="患者姓名">
            <el-input v-model="searchData.name" type="text" clearable placeholer="请输入"></el-input>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-model="searchData.time" type="daterange"
              range-separator="-" placeholder="请选择"></el-date-picker>
          </el-form-item>
          <div class="searchBut">
            <el-button class="color-main" @click="resetForm" type="primary">
              <i class="fa fa-refresh"></i>重置
            </el-button>
            <el-button @click="handleSearch" class="color-main" type="primary">
              <i class="fa fa-search"></i>查询
            </el-button>
          </div>
        </el-form>

      </div>
    </div>
    <el-divider></el-divider>
    <div class="tabSet">
      <div :class="tabIndex==1?'active':''" @click="handleChange(1)">透析治疗</div>
      <div :class="tabIndex==2?'active':''" @click="handleChange(2)">普通门诊</div>
    </div>
    <div class="mian" ref="tableBoxRef">
      <div class="left">
        <div class="patientList">
          <div class="table">
            <el-table v-loading="dataListLoading" :row-style="rowStyle" @row-click="Rowclick" v-if="istable"
              :data="tableData" class="table-ellipsis" size="small" border :max-height="tableHei">
              <el-table-column type="index" label="编号" fixed min-width="80" align="center">
                <template #default="scope">
                  {{ (pageData.page - 1) * pageData.size + (scope.$index + 1) }}
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template #default="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="sex" label="性别" align="center" />
              <el-table-column prop="age" label="年龄" align="center" />
              <el-table-column prop="bed_time" label="就诊时间" align="center" show-overflow-tooltip />
              <el-table-column prop="admin_user_name" label="医生" align="center" show-overflow-tooltip />
              <el-table-column prop="fee" label="金额" align="center" show-overflow-tooltip />
              <el-table-column label="取药">
                <template #default="scope">
                  {{ scope.row.send_status==1?'已发药':'未发药' }}
                </template>
              </el-table-column>
            </el-table>
            <div class="tip">
              <div class="tooltips">
                本页小计：人数：{{current_count}}，金额：{{current_fee}}元
              </div>
              <div class="tooltips">
                总计：人数：{{total_count}}，金额：{{total_fee}}元
              </div>
            </div>
            <div class="pagination-box">
              <el-pagination :page="pageData.page" :page-size="pageData.size" :page-sizes="[10, 20, 50, 100]"
                :background="true" layout="total, sizes, prev, pager, next, jumper" :total="pageData.totalSum"
                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="patientList">
          <div class="tooltip">
            <div>
              姓名：{{info.name?info.name:'请选择'}}，费用：{{info.total_fee?info.total_fee:0}}元
            </div>
            <div style="display: flex;align-items: center;">

              <el-dropdown style="margin-right: 10px;">
                <el-button>
                  打印<el-icon class="el-icon--right"><arrow-down /></el-icon>
                </el-button>
                <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="print(item)" v-for="item in dictList['909100000']" :key="item.code">{{item.name}}</el-dropdown-item>
                      <el-dropdown-item @click="printInfo('1')">清单</el-dropdown-item>
                    </el-dropdown-menu>

                </template>
              </el-dropdown>

            </div>
          </div>
          <div class="zhenduan">
            诊断：{{info.diagnosis?info.diagnosis:'请先选择患者'}}
          </div>
          <div class="table">
            <el-table v-loading="dataListLoadingChild" v-if="istable" :data="tableDataChild" class="table-ellipsis"
              size="small" border :max-height="tableHei">
              <el-table-column label="名称" width="180" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column prop="dict_first_unit_name" label="单位" align="center" />
              <el-table-column prop="medi_spec" label="规格" align="center" />
              <el-table-column prop="company" label="厂家" align="center" />
              <el-table-column prop="num" label="数量" align="center" show-overflow-tooltip />
              <el-table-column prop="sell_price" label="单价" align="center" show-overflow-tooltip />
              <el-table-column prop="fee" label="小计" align="center" show-overflow-tooltip />
            </el-table>
          </div>
          <div class="title">处方点评</div>
          <el-input v-model="idRow.judge_content" :disabled="idRow.judge_status==0?false:true" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea"
            placeholder="请输入" style="margin: 10px 0;"/>

          <div class="display_flex" style="display: flex;justify-content: space-between;">
            <span>
              <el-button @click="setStatus(1)" :disabled="idRow.judge_status==0?false:true" type="primary" style="margin-right: 10px;">
                通过
              </el-button>
              <el-button @click="setStatus(2)" :disabled="idRow.judge_status==0?false:true" type="danger" style="margin-right: 10px;">
                不通过
              </el-button>
            </span>
            <el-button  :loading="saveLoad" :disabled="idRow.judge_status==2?true:false" @click="sendThing" type="success" v-if="idRow.send_status==0">
              发药
            </el-button>
          </div>
          
        </div>
      </div>
    </div>
    <feeCom ref="feeComRef"></feeCom>
    <puTong ref="puTongRef"></puTong>
    <jing ref="jingRef"></jing>
  </div>
</template>
<script>
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount,
    getCurrentInstance
  } from 'vue'
  import service from '@/utils/request'
  import { gitDictList, gitDictVal, TimestampToTime, downLoadXlsx } from '@/utils/tool'
  import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
  import feeCom from './feeCom.vue'
  import puTong from '../TXjilu/advice/puTong.vue'
  import jing from '../TXjilu/advice/jing.vue'
  export default {
    name: 'patentList',
    components: {
      feeCom,
      puTong,
      jing
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        searchData: {
          time: '',
          name: '',
        },
        saveLoad:false,
        pageData: {
          page: 1,
          size: 10,
          totalSum: 0,
        },
        dataListLoading: false,
        dataListLoadingChild: false,
        tableData: [],
        tableDataChild: [],
        dictList: {},
        searchForm: null,
        tableHei: 0,
        istable: false,
        tableBoxRef: null,
        viewDialogRef: null,
        activeName: '1',
        idRow: '',
        tabIndex: '1',
        current_count: '',
        current_fee: '',
        total_count: '',
        total_fee: '',
        info: '',
        judge_status:''
      })
      onMounted(() => {
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        state.istable = false
        state.tableHei = state.tableBoxRef.clientHeight - 140
        console.log(state.tableHei)
        nextTick(() => {
          state.istable = true
        })
        getDataList()
        getDict()
      })
      const handleChange = (code) => {
        state.tabIndex = code
        getDataList()
      }
      const handleSizeChange = (val) => {
        state.pageData.size = val
        getDataList()
      }
      const getDict = async () => {
        state.dictList = await gitDictList([
          '909100000'
        ])
      }
      const handleCurrentChange = (val) => {
        state.pageData.page = val
        getDataList()
      }

      const resetForm = () => {
        Object.keys(state.searchData).forEach((key) => (state.searchData[key] = ""))
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        handleSearch()
      }
      const handleSearch = () => {
        state.pageData.page = 1
        getDataList()
      }

      const getDataList = async () => {
        state.dataListLoading = true
        let data = {}
        if (state.searchData.time) {
          data = {
            type: state.tabIndex,
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1],
            page: state.pageData.page,
            size: state.pageData.size,
            name: state.searchData.name,
          }
        } else {
          data = {
            type: state.tabIndex,
            page: state.pageData.page,
            size: state.pageData.size,
            name: state.searchData.name,
          }
        }
        let res = await service.post(
          '/api/drug_record/get_list',
          data
        )
        state.dataListLoading = false
        if (res.code === 0) {
          if (res.data.list.length > 0) {
            state.tableData = res.data.list
            state.pageData.totalSum = res.data.total_count
            state.current_count = res.data.current_count
            state.current_fee = res.data.current_fee.toFixed(2)
            state.total_count = res.data.total_count
            state.total_fee = res.data.total_fee.toFixed(2)
            state.idRow = res.data.list[0]
            detail(state.idRow.id)
          } else {
            state.tableData = []
            state.pageData.totalSum = 0
            state.current_count = 0
            state.current_fee = 0
            state.total_count = 0
            state.total_fee = 0
          }
        }
      }
      // 左侧表格点击
      const Rowclick = (row) => {
        state.idRow = row
        detail(row.id)
      }
      const rowStyle = (row) => {
        if (state.idRow.id == row.row.id) {
          return { 'background-color': '#ccc', cursor: 'pointer', 'color': '#333' };
        }
        return { cursor: 'pointer' };
      }
      // 右侧表格列表
      const detail = async (id) => {
        state.dataListLoadingChild = true
        let res = await service.post('/api/drug_record/get_detail', { bed_reg_id: id, type: state.tabIndex })
        if (res.code === 0) {
          state.tableDataChild = res.data.advice_list
          state.info = res.data
          state.info.total_fee = res.data.total_fee.toFixed(2)
          state.dataListLoadingChild = false
        } else {
          state.tableDataChild = []
        }
      }
      const tableDataList = ref([])
      const tableDataInfo = ref({})
      //获取药品列表
      const getData = async (item) => {
        let res = await service.post(
          '/api/printData/getFeeList',
          { bed_reg_id: item.bed_reg_id }
        )
        if (res.code === 0) {
          console.log(res.data)
          tableDataList.value = res.data.fee_list
          tableDataInfo.value = res.data.bill
          if (tableDataList.value.length <= 0) {
            ElMessage.error('暂无打印信息')
          } else {
            let data = {
              ...tableDataInfo.value,
              drug_list: tableDataList.value,
              totals: tableDataInfo.value.total_fee.toFixed(2),  //总金额
              yiTotal: 0,
              ziTotal: 0,
            }
            proxy.$refs.feeComRef.initData(data)
            nextTick(() => {
              proxy.$refs.feeComRef.print()
            })
          }


        }
      }
      const printInfo = async (types) => {
        if (state.idRow == '') {
          ElMessage.error('请先选择患者')
        } else {
          //打印清单
          getData(state.idRow)
        }
      }
      const print = async (types) => {
        if (state.idRow == '') {
          ElMessage.error('请先选择患者')
        } else {
          // 2 putong 3 jing
            let data = {}
            let url = ''
            if (state.tabIndex == 1) {
              data = {
                type: types.code,
                record_id: state.idRow.record_id,
                bed_reg_id: state.idRow.bed_reg_id
              }
              url = '/api/printData/getRecordDrugList'

            } else {
              url = '/api/printData/getBedRegDrugList'
              data = {
                type: types.code,
                bed_reg_id: state.idRow.bed_reg_id
              }
            }
            let res = await service.post(
              url,
              data
            )
            if (res.code === 0) {
              if (res.data.drug_list.length == 0) {
                ElMessage.error('暂无打印药品');
              } else {
                proxy.$refs.puTongRef.info = res.data
                proxy.$refs.puTongRef.info.typeName = types.name.substring(0, 2)
                proxy.$refs.puTongRef.initData(res.data)
                nextTick(() => {
                  proxy.$refs.puTongRef.print()
                })
              }
            }
        }
      }
      const sendThing = async () => {
        if(state.idRow.judge_status==1){
          state.saveLoad = true
        let url = '/api/drug_record/send_drug'
        let res = await service.post(
          url,
          { bed_reg_id: state.idRow.bed_reg_id, type: state.tabIndex }
        )
        if (res.code === 0) {
          state.saveLoad = false
          ElMessage.success('发药成功');
          state.idRow.send_status = 1
        }else{
          state.saveLoad = false
        }
      }else{
        ElMessage.error('请先点评');
      }
      }
      const setStatus = (code) =>{
        state.judge_status = code
          if(code==2){
             if(state.idRow.judge_content==''){
              ElMessage.error('请输入备注');
             }else{
              //设置不通过
              setInfo()
             }
          }else{
            setInfo()
          }
      }
      const setInfo = async () => {
        let url = '/api/drug_record/judge_drug'
        let data = {
          bed_reg_id: state.idRow.bed_reg_id,
          type: state.tabIndex,
          judge_status:state.judge_status,
          judge_content:state.idRow.judge_content
        }
        let res = await service.post(
          url,
          data
        )
        if (res.code === 0) {
          ElMessage.success('点评成功');
          state.idRow.judge_status = state.judge_status
        }
      }
      
      return {
        ...toRefs(state),
        handleSizeChange,
        handleCurrentChange,
        handleSearch,
        getDataList,
        resetForm,
        Rowclick,
        setInfo,
        detail,
        print,
        rowStyle,
        handleChange,
        sendThing,
        setStatus,
        getDict,
        printInfo
      }
    },
  }
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
  .tabSet {
    height: 40px;
    width: 100%;
    line-height: 40px;
    display: flex;
    justify-content: start;
    align-items: center;
    border-bottom: 2px solid #e4e7ed;

    div {
      margin-right: 20px;
      color: #333;
      border-bottom: none;
    }

    .active {
      color: #3166ae;
      border-bottom: 2px solid #3166ae;
    }
  }

  .mian {
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
    }

    .right {
      width: 49%;
    }
  }

  .tip {
    height: 40px;
    font-weight: 700;
    background-color: #eaf0f7 !important;
    color: #3166ae;
    display: flex;
    justify-content: space-around;
    align-items: center;

  }

  .tooltip {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 700;
    background-color: #eaf0f7 !important;
    color: #3166ae;
    text-align: left;
    line-height: 50px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .zhenduan {
    font-weight: 700;
    padding-top: 2px;
    padding-bottom: 10px;
    color: #3166ae;
    background-color: #eaf0f7 !important;
    padding-left: 10px;
  }

  .search-top {
    margin-top: 10px;
  }

  .demo-form-inline {
    margin-top: 0;
    //flex: 1;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-template-rows: repeat(1, 20px);
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .search-top .w-208 {
    width: 208px;
    margin-top: 10px;
  }

  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .mian {
    height: calc(100% - 100px);
  }

  .patientList {
    margin-top: 10px;
    /* height: calc(100% - 100px); */
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    margin-top: 10px;
    height: calc(100% - 10px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {
    width: 100%;
    display: flex;
    justify-content: end;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .labelSet1 {
    width: 60px;
    height: 30px;
    line-height: 30px;
    display: block;
    text-align: center;
    color: #fff;
    border-radius: 5px;
  }

  .psckset {
    background-color: #409EFF;
  }

  .psckset1 {
    background-color: #a4cef8;
    color: #1581fc;
    border: 1px solid #1581fc;
  }

  .lcsyset {
    background-color: #c6f1b1;
    color: #3bb207;
    border: 1px solid #5bd324;
  }

  .lcsyset1 {
    background-color: #f1beb1;
    color: #f35c0c;
    border: 1px solid #f35c0c;
  }
  .title{
    width: 100%;
    font-size: 14px;
    font-weight: 700;
    margin-top: 5px;
  }
</style>